// extracted by mini-css-extract-plugin
module.exports = {"headings":"index__headings___dxrWG","unsuccessful":"index__unsuccessful___HHbvO","unsuccessfulText":"index__unsuccessfulText___f_yp0","seeAllButton":"index__seeAllButton___1CGRO"};